module.exports = {
    
    validateUsername : [
        v => v.length <= 255 || 'Name must be less than 255 characters'
    ]
    ,validatePassword : [
        v => v.length <= 255 || 'Password must be less than 255 characters'
    ]

}
